// @flow
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import Overpanel from 'react-components/overpanel'
import ThreeDS2ChallengeIframe from './ThreeDS2ChallengeIframe'
import { toggle3DS2ChallengeOverpanel } from '../../actions/overpanels'
import {
  handleThreeDS2Success,
  handleThreeDS2Failure,
} from '../../actions/send'
import { showError } from '../../actions/Actions'
import content from 'pp-react-l10n'
const i18n = content('transfer/3ds/error')
const i18nWallet = content('wallet/walletAlertDialogs')

const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(...args))

type Props = Overpanel & {
  handleFailure: () => void,
  handleSuccess: () => void,
  onSuccess?: () => void,
  dispatch: () => void,
}
export function ThreeDS2OverPanel({
  show,
  handleClose,
  dispatch,
  handleFailure,
  handleSuccess,
  onSuccess = () => {},
}: Props) {
  return (
    <Overpanel show={show} handleClose={handleFailure} hideCloseButton={true}>
      <ThreeDS2ChallengeIframe
        dispatch={dispatch}
        handle3DS2Success={callAll(handleSuccess, onSuccess)}
        handle3DS2Failure={handleFailure}
      />
    </Overpanel>
  )
}

export default connect(
  ({ overpanels }) => ({
    show: overpanels.showThreeDS2ChallengeIframe,
  }),
  dispatch => ({
    handleSuccess: (event, params) => {
      dispatch(toggle3DS2ChallengeOverpanel({ show: false }))
      dispatch(handleThreeDS2Success(params))
    },
    handleFailure: err => {
      dispatch(toggle3DS2ChallengeOverpanel({ show: false }))
      dispatch(handleThreeDS2Failure())
      if (err) {
        let errMsg = ''
        if (err.includes('errorPaymentFailedForFundingSource')) {
          errMsg = i18n('threeDS2.errorPaymentDeniedForFundingSource')
        } else {
          errMsg = i18nWallet('walletAlertDialogs.internalServerError')
        }
        // Added setTimeout as multiple action dispatch causes the screen to freeze
        setTimeout(() => {
          dispatch(
            showError({
              message: errMsg,
            })
          )
        }, 400)
      }
    },
  })
)(ThreeDS2OverPanel)
